if (!customElements.get('petomg-care-program')) {
  class PetomgCareProgram extends HTMLElement {
    connectedCallback() {
      if (this.dataset.pcpReady === 'true') return;

      this.dataset.pcpReady = 'true';
      this.faqItems = Array.from(this.querySelectorAll('[data-pcp-faq-item]'));
      this.handleClick = this.handleClick.bind(this);
      this.handleFaqToggle = this.handleFaqToggle.bind(this);

      this.addEventListener('click', this.handleClick);
      this.faqItems.forEach((item) => {
        item.addEventListener('toggle', this.handleFaqToggle);
        this.syncFaqState(item);
      });

      this.closeExtraOpenFaqs();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.faqItems?.forEach((item) => item.removeEventListener('toggle', this.handleFaqToggle));
      delete this.dataset.pcpReady;
    }

    handleClick(event) {
      const trigger = event.target.closest('[data-pcp-scroll-link]');
      if (!trigger || !this.contains(trigger)) return;

      const href = trigger.getAttribute('href') || '';
      if (!href.startsWith('#') || href.length <= 1) return;

      const target = document.getElementById(href.slice(1));
      if (!target) return;

      event.preventDefault();

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    }

    handleFaqToggle(event) {
      const activeItem = event.currentTarget;

      if (activeItem.open) {
        this.faqItems.forEach((item) => {
          if (item !== activeItem) item.open = false;
        });
      }

      this.faqItems.forEach((item) => this.syncFaqState(item));
    }

    closeExtraOpenFaqs() {
      let firstOpenItem = null;

      this.faqItems.forEach((item) => {
        if (!item.open) return;

        if (!firstOpenItem) {
          firstOpenItem = item;
          return;
        }

        item.open = false;
        this.syncFaqState(item);
      });
    }

    syncFaqState(item) {
      const summary = item.querySelector('[data-pcp-faq-summary]');
      if (!summary) return;

      summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
    }
  }

  customElements.define('petomg-care-program', PetomgCareProgram);
}
